/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S3_TitleInputs */

const en_fc_tut_s3_title = /** @type {(inputs: Fc_Tut_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import your media`)
};

/**
* | output |
* | --- |
* | "Import your media" |
*
* @param {Fc_Tut_S3_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s3_title = /** @type {((inputs?: Fc_Tut_S3_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S3_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s3_title(inputs)
});
export { fc_tut_s3_title as "fc.tut.s3.title" }